import { CollectionOverviewContentReatom } from "./view/index.reatom"

export function CollectionOverviewReatom() {
  return <CollectionOverviewContentReatom />
}
